package com.zq.webproject

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlin.js.js

/**
 * Web 平台实现：从浏览器 URL 获取邀请码参数
 */
@Composable
actual fun getInvitationCodeFromUrl(): String? {
    return remember {
        try {
            // 使用 js() 调用浏览器 API 获取 URL 参数
            val urlParams = js("new URLSearchParams(window.location.search)")
            val inviteCode = js("urlParams.get('inviteCode')") as? String
            
            println("getInvitationCodeFromUrl (Web) - URL参数: $inviteCode")
            inviteCode
        } catch (e: Exception) {
            println("getInvitationCodeFromUrl (Web) - 获取失败: ${e.message}")
            null
        }
    }
}
